import React from "react";
import "./resume.css";
const Resume = () => (
  <iframe
    title="title"
    className="responsive-iframe"
    src="Ameer-Alaswad-CV.pdf"
    height="1165"
  />
);
export default Resume;
